import PanelPage from "../../components/panel/panelPage";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { useParams } from "react-router-dom";
import EventDetailInfoCard from "../../components/events/infoCard";
import CommentsList from "../../components/comments/list";
import { EventFullData } from "../../types";
import PreloaderPage from "../preloader";
import { eventBackend, statsBackend } from "../../services";
import ErrorPage from "../error";
import { toast } from "sonner";

const markRead = async (eventid: number, userid: number) => {
  try {
    await statsBackend.markPageRead({
      tab_id: 1,
      item_id: eventid,
      user_id: userid,
    });
  } catch (e) {
    console.error("Ошибка сохранения:", e);
    toast("Ошибка сохранения");
  }
};

const EventDetailPage = () => {
  const [eventData, setEventData] = useState<EventFullData | null>(null);
  const [errored, setErrored] = useState(false);
  const { eventid } = useParams();
  const [update, triggerUpdate] = useState(true);
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  if (!eventid || isNaN(Number(eventid)) || errored) {
    return <ErrorPage code={404} message={"Событие не найдено"} />;
  }

  const trigger = State.selectedItem;
  const session = State.session;

  useEffect(() => {
    eventBackend
      .getEventFullData(Number(eventid))
      .then((res) => {
        if (res?.event) {
          setEventData(res.event);
        } else {
          setErrored(true);
        }
      })
      .catch((e) => {
        setErrored(true);
      });
      if (session) markRead(Number(eventid), session?.id)
  }, [trigger]);

  const handleOpenModal = () => {
    console.log("Called");
    triggerUpdate((state) => !state);
  };

  if (!eventData) {
    return <PreloaderPage />;
  }

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <div className="panelHeading">
          <h2>Событие № {eventid}</h2>
        </div>
        <div className="flex between w100 panelColumnFull">
          <div className="columnCenter panelColumn2">
            <div className="panel eventListPanel">
              <EventDetailInfoCard data={eventData} />
            </div>
          </div>
          <div className="columnCenter panelColumn2">
            <div className="panel eventListPanel">
              <CommentsList
                comments={eventData.comments}
                item={eventData.event_id}
                tab={1}
              />
            </div>
          </div>
        </div>
      </div>
    </PanelPage>
  );
};

export default EventDetailPage;
